import React from "react";
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Button,
} from '@lockerpm/design';

import {
  KeyOutlined,
  UsbOutlined,
} from "@ant-design/icons";

const SelectUnlockMethod = (props) => {
  const { t } = useTranslation();
  const {
    callingAPI,
    setStep,
    setIsPair,
    setOtherMethod,
  } = props;

  const isConnected = useSelector((state) => state.service.isConnected);

  const selectOtherMethod = (method) => {
    setStep(2);
    setOtherMethod(method);
    if (method === 'security_key') {
      setIsPair(!isConnected || !service.hasPairingKey);
    } else {
      setIsPair(false)
    }
  }

  return (
    <div>
      <Button
        className="w-full mb-4"
        size="large"
        ghost
        type="primary"
        icon={<KeyOutlined />}
        disabled={callingAPI}
        onClick={() => selectOtherMethod('passkey')}
      >
        {t('auth_pages.sign_in.your_passkey')}
      </Button>
      <Button
        className="w-full"
        size="large"
        ghost
        type="primary"
        icon={<UsbOutlined />}
        disabled={callingAPI}
        onClick={() => selectOtherMethod('security_key')}
      >
        {t('auth_pages.sign_in.your_security_key')}
      </Button>
    </div>
  );
}

export default SelectUnlockMethod;